import { HttpContextToken } from '@angular/common/http';

/**
 * Set on a request to opt it out of AuthInterceptor's 401 handling — a
 * refresh-and-retry only makes sense for a request that expected an
 * existing session. Requests that run before one exists (login, token
 * refresh itself, set-password) should let a 401 through as-is.
 */
export const SKIP_AUTH_REFRESH = new HttpContextToken<boolean>(() => false);
